import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: false,
}

export const journeyTollData = createSlice({
    name: 'journeyTollData',
    initialState,
    reducers: {
        addTollData: (state, action) => {
            state.value = (action.payload);
        },
    },
})

// Action creators are generated for each case reducer function
export const { addTollData } = journeyTollData.actions

export default journeyTollData.reducer